var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 359,
    viewBox: "0 -10 358 359",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_931_3046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5259 271.533L76.467 305.474L103.337 292.746L55.2538 244.663L42.5259 271.533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.469 66.4692L281.528 32.5281L254.658 45.256L302.741 93.3393L315.469 66.4692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.998 338.002L202.998 338.002L212.998 310.002L144.998 310.002L154.998 338.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.997 -1.26763e-06L154.997 -2.18557e-07L144.997 28L212.997 28L202.997 -1.26763e-06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.529 305.473L315.47 271.532L302.742 244.662L254.659 292.745L281.529 305.473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4663 32.5288L42.5252 66.4699L55.2531 93.34L103.336 45.2567L76.4663 32.5288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.001 193.001L348.001 145.001L320.001 135.001L320.001 203.001L348.001 193.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 145.001L10 193.001L38 203.001L38 135.001L10 145.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.991,
    cy: 169.001,
    r: 145,
    transform: "rotate(-90 178.991 169.001)",
    stroke: "white",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.998,
    cy: 169.001,
    r: 127,
    transform: "rotate(-90 178.998 169.001)",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-1_931_3046",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.402 275.132C209.791 273.38 231.051 264.585 248.134 250.008L234.328 233.829C220.662 245.491 203.654 252.527 185.743 253.928L187.402 275.132Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187.402 275.132C209.791 273.38 231.051 264.585 248.134 250.008L234.328 233.829C220.662 245.491 203.654 252.527 185.743 253.928L187.402 275.132Z",
    stroke: "white",
    strokeWidth: 36,
    mask: "url(#path-11-inside-1_931_3046)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-2_931_3046",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.939 238.214C274.531 221.144 283.345 199.892 285.117 177.505L263.915 175.826C262.497 193.736 255.446 210.738 243.772 224.394L259.939 238.214Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.939 238.214C274.531 221.144 283.345 199.892 285.117 177.505L263.915 175.826C262.497 193.736 255.446 210.738 243.772 224.394L259.939 238.214Z",
    stroke: "white",
    strokeWidth: 36,
    mask: "url(#path-12-inside-2_931_3046)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-3_931_3046",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.124 160.817C283.372 138.428 274.577 117.168 260 100.085L243.821 113.891C255.483 127.557 262.519 144.565 263.921 162.476L285.124 160.817Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M285.124 160.817C283.372 138.428 274.577 117.168 260 100.085L243.821 113.891C255.483 127.557 262.519 144.565 263.921 162.476L285.124 160.817Z",
    stroke: "white",
    strokeWidth: 36,
    mask: "url(#path-13-inside-3_931_3046)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-4_931_3046",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.206 88.2805C231.136 73.6879 209.884 64.8741 187.497 63.1021L185.819 84.3043C203.729 85.7219 220.73 92.773 234.386 104.447L248.206 88.2805Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M248.206 88.2805C231.136 73.6879 209.884 64.8741 187.497 63.1021L185.819 84.3043C203.729 85.7219 220.73 92.773 234.386 104.447L248.206 88.2805Z",
    stroke: "white",
    strokeWidth: 36,
    mask: "url(#path-14-inside-4_931_3046)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-5_931_3046",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.809 63.0944C148.42 64.8464 127.16 73.6413 110.077 88.2185L123.883 104.397C137.549 92.7356 154.557 85.6997 172.468 84.2981L170.809 63.0944Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.809 63.0944C148.42 64.8464 127.16 73.6413 110.077 88.2185L123.883 104.397C137.549 92.7356 154.557 85.6997 172.468 84.2981L170.809 63.0944Z",
    stroke: "white",
    strokeWidth: 36,
    mask: "url(#path-15-inside-5_931_3046)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-16-inside-6_931_3046",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.2726 100.013C83.6801 117.083 74.8662 138.335 73.0942 160.722L94.2965 162.4C95.7141 144.49 102.765 127.489 114.439 113.833L98.2726 100.013Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.2726 100.013C83.6801 117.083 74.8662 138.335 73.0942 160.722L94.2965 162.4C95.7141 144.49 102.765 127.489 114.439 113.833L98.2726 100.013Z",
    stroke: "white",
    strokeWidth: 36,
    mask: "url(#path-16-inside-6_931_3046)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-7_931_3046",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.0868 177.41C74.8388 199.799 83.6337 221.058 98.2109 238.141L114.39 224.336C102.728 210.669 95.6921 193.662 94.2906 175.75L73.0868 177.41Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.0868 177.41C74.8388 199.799 83.6337 221.058 98.2109 238.141L114.39 224.336C102.728 210.669 95.6921 193.662 94.2906 175.75L73.0868 177.41Z",
    stroke: "white",
    strokeWidth: 36,
    mask: "url(#path-17-inside-7_931_3046)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-8_931_3046",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.006 249.946C127.076 264.539 148.328 273.353 170.715 275.125L172.393 253.922C154.483 252.505 137.482 245.454 123.826 233.78L110.006 249.946Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.006 249.946C127.076 264.539 148.328 273.353 170.715 275.125L172.393 253.922C154.483 252.505 137.482 245.454 123.826 233.78L110.006 249.946Z",
    stroke: "white",
    strokeWidth: 36,
    mask: "url(#path-18-inside-8_931_3046)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.998,
    cy: 169.001,
    r: 50,
    transform: "rotate(-90 178.998 169.001)",
    stroke: "white",
    strokeWidth: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.498,
    y1: 19.001,
    x2: 179.498,
    y2: 319.001,
    stroke: "white",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.9976,
    y1: 168.501,
    x2: 328.998,
    y2: 168.501,
    stroke: "white",
    strokeDasharray: "2 2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_931_3046",
    x: 0,
    y: 0,
    width: 358.001,
    height: 358.002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_931_3046"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_931_3046",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeerMenu);
export default __webpack_public_path__ + "static/media/geerMenu.45f88526d90a45ebf20897404967409a.svg";
export { ForwardRef as ReactComponent };